import { NA } from "@/admin/AdminTable.tsx";
import { adminAllHostPoolsQueryAtom } from "@/admin/host_pools/hostPoolsQuery.ts";
import { WTooltip } from "@/components/WTooltip.tsx";
import { errorToReactMessage } from "@/modules/notifications/errorToReactMessage.tsx";
import { useAtomValue } from "jotai";

export function HostPoolItem({ value }: { value: string }) {
    const { error, data: pools } = useAtomValue(adminAllHostPoolsQueryAtom);
    const pool = pools.get(value);

    return pool ? (
        <>
            <span className="text-nowrap">{pool.name}</span> ({pool.location})
        </>
    ) : // NB: Error case comes after existence check since data might still be partially available
    error ? (
        <WTooltip text={errorToReactMessage(error)}>⚠️</WTooltip>
    ) : (
        <NA />
    );
}
